import { render, staticRenderFns } from "./tracking.vue?vue&type=template&id=2dc2690b&scoped=true"
import script from "./tracking.vue?vue&type=script&lang=js"
export * from "./tracking.vue?vue&type=script&lang=js"
import style0 from "./tracking.vue?vue&type=style&index=0&id=2dc2690b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2690b",
  null
  
)

export default component.exports